function getCookie(cname) {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function setCookie(cname = '', value = '', expires = false, days = 1) {
  let str = '';
  if (cname !== '') {
    str += `${cname}=${value.toString()};`;
  }
  if (expires) {
    const expr = new Date(new Date().getTime() + days * 24 * 60 * 60 * 1000).toUTCString();
    str += `expires=${expr};`;
  }
  document.cookie = str;
}

function CreateToggle(toggleID, bodyClassName) {
  const toggle = document.getElementById(toggleID);
  const body = document.body || document.querySelector('body');

  if (toggle) {
    toggle.addEventListener('click', () => {
      if (body && body.classList) {
        body.classList.toggle(bodyClassName);
        window.dispatchEvent(new Event('resize'));
        setCookie(bodyClassName, body.classList.contains(bodyClassName));
      }
    });
  }

  if (getCookie(bodyClassName) === 'true') {
    if (body && body.classList) {
      body.classList.add(bodyClassName);
    }
  }
}

function Toggles() {
  CreateToggle('dnn-toggle', 'dnn-nav-hidden');
  CreateToggle('header-toggle', 'header-hidden');
}

export default Toggles;
